import { render } from "./TableSortField.vue?vue&type=template&id=14a0aed8&scoped=true"
import script from "./TableSortField.vue?vue&type=script&lang=js"
export * from "./TableSortField.vue?vue&type=script&lang=js"

import "./TableSortField.vue?vue&type=style&index=0&id=14a0aed8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a0aed8"]])

export default __exports__